import * as core from '../../../../../../../core'
import * as idcRateGroup from '../idc-rate-group'

export const RESOURCE = {
  payload: {
    description: 'TODO',
    enumId: core.dms.models.Enum.Id.from({
      partialId: idcRateGroup.RESOURCE.payload.partialId,
    }),
    id: 'FederalResearchTraining',
    name: 'Federal - Research Training',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
